// eslint-disable-next-line no-restricted-imports
import { Query_ClientController_GetList_AllOf_1_List_Items_Representative_TaxResidences_Items_Documents_Items_CreatedBy_Type as DocumentCreatedByType } from 'api/generated/graphql';
import { PersonalAccountEntity } from 'api/types/entity/personalAccountEntity';

interface PersonalAccountApi {
  number?: string | null;
  openingDate?: string | null;
  closingDate?: string | null;
  freezingDate?: string | null;
  createdBy: {
    type: DocumentCreatedByType;
  };
}

export const parsePersonalAccountEntity = (
  personalAccount?: PersonalAccountApi | null
): PersonalAccountEntity => ({
  number: personalAccount?.number ?? undefined,
  openingDate: personalAccount?.openingDate
    ? new Date(personalAccount.openingDate)
    : undefined,
  closingDate: personalAccount?.closingDate
    ? new Date(personalAccount.closingDate)
    : undefined,
  freezingDate: personalAccount?.freezingDate
    ? new Date(personalAccount.freezingDate)
    : undefined,
  isCreatedBySystem:
    personalAccount?.createdBy.type === DocumentCreatedByType.Service,
});
